import React from 'react'
// import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
const isMobile = browserCheck.isMobile

export const qanda = [
  {
    nummer: 1,
    type: 'slider',
    question:
      'Alle Schweizer Steuerpflichtigen zusammen besitzen ein Reinvermögen von 1994 Milliarden Franken. Schätzen Sie: Wie viel Prozent davon gehören der ärmeren Hälfte?',
    correctAnswer: 1.5,
    erklaerung: (
      <>
        <h5>Interessant zu wissen:</h5>
        <p>
          Die ärmere Hälfte besitzt also gerade mal 1,4 Prozent des gesamten
          Reinvermögens. Zusammen kommen die 2,9 Millionen Steuerpflichtigen,
          welche je ein Vermögen von weniger als 50’000 Franken versteuern, auf
          28 Milliarden Franken. Das ist ein Klacks im Vergleich zum gesamten
          Reinvermögen von 1994 Milliarden. Genau genommen verteilen sich diese
          28 Milliarden Franken sogar auf etwas mehr als die Hälfte aller
          Steuerpflichtigen, nämlich auf 55 Prozent der Haushalte.
        </p>
      </>
    )
  },
  {
    nummer: 2,
    type: 'slider',
    question:
      'Richten wir nun das Augenmerk auf die Reichsten – nicht auf die ganze andere Hälfte, sondern nur auf die 0,3 Prozent Vermögendsten. Schätzen Sie: Wie gross ist der Anteil dieser 0,3 Prozent Reichsten am gesamten Reinvermögen?',
    correctAnswer: 32,
    erklaerung: (
      <>
        <h5>Interessant zu wissen:</h5>
        <p>
          All diese 17’000 Gutbetuchten versteuern je mehr als 10 Millionen
          Franken. Zusammen kommen sie auf 646 Milliarden. Damit besitzen die
          0,3 Prozent Reichsten 32 Prozent des gesamten Reinvermögens.
        </p>
      </>
    )
  },
  {
    nummer: 3,
    type: 'map',
    question:
      'Auch regional zeigen sich deutliche Unterschiede. Was denken Sie: In welchem Kanton ist die Dichte an Millionären am höchsten?',
    correctAnswer: 'ZG',
    erklaerung: (
      <>
        <h5>Interessant zu wissen:</h5>
        <p>
          Jeder Achte im Kanton Zug ist Millionär. Auf 1000 Steuerpflichtige
          kommen 132 mit einem Reinvermögen von mindestens einer Million
          Franken. Damit ist die Millionärsdichte in Zug am höchsten.
        </p>
        <div className='iframeWrapper'>
          <div className='chartTitle'>Millionäre zieht es an den Zugersee</div>
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/69BgL/'
            // style={{ height: '100%' }}
          />
        </div>
        <p>
          Ganz anders im Jura. Dort ist nur jeder Fünfzigste Millionär. Auch in
          den Kantonen Freiburg und Solothurn ist die Millionärsdichte relativ
          tief. Stattdessen lassen sich die Reichen lieber in der
          steuergünstigen Zentralschweiz nieder. Insgesamt zählt die Schweiz
          330'215 Millionäre. Das entspricht sechs Prozent aller
          Steuerpflichtigen.
        </p>
      </>
    )
  },
  {
    nummer: 4,
    type: 'map',
    question:
      'In welchem Kanton ist das durchschnittliche Vermögen am höchsten?',
    correctAnswer: 'NW',
    erklaerung: (
      <>
        <h5>Interessant zu wissen:</h5>
        <p>
          Am meisten Vermögen pro Kopf konzentriert sich in Nidwalden, nicht
          etwa in Zug oder Schwyz. Dies, obwohl Nidwalden bei der
          Millionärsdichte deutlich tiefer liegt als die beiden anderen
          Zentralschweizer Kantone. Möglich wird dies durch Superreiche, die das
          Durchschnittsvermögen nach oben treiben. Dieses beträgt in Nidwalden
          beeindruckende 1,3 Millionen Franken. Im Schnitt – und wir betonen: im
          Schnitt – sind die Nidwaldner also Millionäre. Die Jurassier auf der
          anderen Seite versteuern lediglich ein Zehntel des Reinvermögens, das
          die Nidwaldner deklarieren. Der gesamtschweizerische Schnitt liegt bei
          373’000 Franken. Warum Nidwalden derart attraktiv ist für Vermögende,
          erfahren Sie bei der nächsten Frage (die jetzt nicht mehr so schwierig
          zu beantworten ist).
        </p>
        <div className='iframeWrapper' style={{marginBottom: '0rem'}}>
          <div className='chartTitle'>
            Reichtum konzentriert sich in der Zentralschweiz
          </div>
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/P7jpA/'
            // style={{ height: '100%', marginBottom: '2rem' }}
          />
        </div>
      </>
    )
  },
  {
    nummer: 5,
    type: 'map',
    question: 'In welchem Kanton zahlen die Vermögenden am wenigsten Steuern?',
    correctAnswer: 'NW',
    erklaerung: (
      <>
        <h5>Interessant zu wissen:</h5>
        <p>
          Nirgendwo sonst in der Schweiz zahlt man derart wenig Vermögenssteuern
          wie in Nidwalden. Während Zug und Schwyz mit tiefen Einkommenssteuern
          brillieren, fokussiert Nidwalden vor allem auf eine tiefe Belastung
          der Vermögenden. Am extremsten ist dies in Hergiswil. Dort müssen die
          Reichen lediglich ein Promille ihres Reinvermögens abgeben. Pro
          Million werden also 1000 Franken fällig. Ganz anders in den
          Neuenburger Gemeinden Enges und Les Verrières. Dort muss ein einfacher
          Millionär mehr als das Siebenfache abliefern, nämlich 7344 Franken.
        </p>
        <p>
          Zürich ist bei einem Vermögen von einer Million Franken relativ
          günstig mit 1900 Franken Vermögenssteuern. Die Belastung beträgt also
          1,9 Promille. Mit zunehmendem Vermögen steigt sie aber stark an. Bei
          10 Millionen werden bereits 5,7 Promille fällig, bei 100 Millionen gar
          6,5 Promille, womit Zürich zu den teureren Standorten gehört. In der
          Limmatstadt werden also vor allem die Superreichen zur Kasse gebeten.
          In Hergiswil dagegen verharrt die Belastung bei 1,0 Promille. Auch der
          Kanton Bern kennt nur eine sehr moderate Progression, das Maximum
          liegt auch bei Superreichen bei 2,4 Promille. In Basel zahlt man bei
          einer Million 4,1 Promille, bei 100 Millionen 5,0 Promille.
        </p>
        <p>
          Generell sind die Vermögenssteuern in der Romandie und der
          Nordwestschweiz höher als im Rest der Schweiz, bei den Superreichen
          kommt Zürich hinzu. Weit günstiger fahren die Vermögenden dagegen in
          der Zentralschweiz, am allergünstigsten wie bereits erwähnt in
          Hergiswil.
        </p>
        <p>
          Nidwalden setzt schon seit Jahrzehnten auf tiefe Vermögenssteuern. Mit
          grossem Erfolg. Vor hundert Jahren hätte wohl niemand gedacht, dass
          dieser Zentralschweizer Kanton dereinst das höchste
          Durchschnittsvermögen ausweisen würde. Der Agrarkanton war schlecht
          erschlossen und kaum industrialisiert. Doch in der Zeit zwischen den
          beiden Weltkriegen entdeckten erste Vermögende das Wohnen am See, das
          zuvor als unattraktiv galt. So liessen sich etwa die Familien
          Schindler (bekannt wegen der Aufzüge) und von Speyr (ihnen gehörte ein
          Teil des Bankvereins, der später mit der Bankgesellschaft zur UBS
          fusionierte) in Hergiswil am Vierwaldstättersee nieder.
        </p>
        <p>
          Sie sollen mehr Steuern bezahlt haben als alle anderen zusammen. Die
          Nidwaldner entdeckten dadurch früh, welch fiskalischer Segen
          zugezogene Reiche sein können. Sie schlossen mit ihnen Verträge ab und
          besteuerten sie pauschal, auch wenn die Vermögenden Schweizer waren.
          Dies sorgte beim Bund und bei anderen Kantonen für Unmut. Nidwalden
          kam unter Druck, liess sich aber Zeit. Erst 1960 war man bereit, ein
          Konkordat zu unterschreiben, wonach die Steuerabkommen nur noch bis
          Ende 1970 zulässig sind.
        </p>
        <p>
          Die Nidwaldner wollten die Reichen aber nicht verlieren und
          reduzierten daher den Vermögenssteuersatz per 1971 erheblich. Dieser
          ist für Hochvermögende besonders wichtig – noch bedeutender als die
          Höhe der Einkommenssteuer. So achteten die Nidwaldner fortan stets
          darauf, hier am günstigsten zu sein.
        </p>
      </>
    )
  },
  {
    nummer: 6,
    type: 'singleChoice',
    question:
      'Wie haben sich die Vermögenssteuern in den letzten 20 Jahren entwickelt?',
    options: [
      'Sie sind überall gestiegen',
      'Sie sind überall gesunken',
      'Sie sind plus/minus stabil geblieben',
      'Sie sind in den ärmeren Kantonen gestiegen und in den reicheren Kantonen gesunken'
    ],
    erklaerung: (
      <>
        <h5>Interessant zu wissen:</h5>
        <p>
          Die Vermögenssteuern kennen in der Schweiz nur eine Richtung: nach
          unten. Damit versuchen alle Kantone wenigstens im Kleinen, Nidwalden
          zu kopieren und Reiche anzulocken – oder zumindest keine Vermögenden
          zu verlieren. Besonders krass hat Uri die Vermögenssteuern gesenkt.
          Waren vor 20 Jahren im Hauptort Altdorf noch 6,3 Promille des
          Reinvermögens fällig, sind es jetzt nur noch 1,9 Promille. Aber auch
          andere Kantone haben ihre Vermögenssteuern markant gesenkt – etwa
          Aargau, Basel-Stadt, Genf, Luzern, Obwalden, Thurgau, Solothurn und
          Schwyz. Am erfolgreichsten ist diese Strategie, wenn ein Kanton damit
          zur Spitzengruppe aufsteigen kann. Die meisten Reichen scheinen sich
          zu sagen: Wenn schon mit einem Umzug die Steuern optimieren, dann
          richtig.
        </p>
        <p>
          Angeführt wird das Rennen nach unten nach wie vor durch Nidwalden.
          Reichte dem Zentralschweizer Kanton 1971 noch ein Steuersatz von
          6 Promille für den Spitzenplatz, würde Nidwalden heute damit zu den
          Teuersten gehören. Das wollen die Zentralschweizer aber auf keinen
          Fall. Heute verlangen die Nidwaldner im Hauptort Stans nur noch
          1,3 Promille und in Hergiswil gar nur 1,0 Promille. Mit der Folge,
          dass ständig weitere Reiche und Superreiche zuziehen, was sich im
          ausserordentlichen hohen Durchschnittsvermögen niederschlägt.
        </p>
      </>
    )
  },
  {
    nummer: 7,
    type: 'map',
    question:
      'In welchem Kanton ist das Durchschnittsvermögen seit 2003 am stärksten gestiegen?',
    correctAnswer: 'OW',
    erklaerung: (
      <>
        <h5>Interessant zu wissen:</h5>
        <p>
          Wenn Sie hier auf Schwyz getippt haben, liegen Sie fast richtig. Das
          durchschnittliche Reinvermögen hat sich dort seit 2003 verdreifacht.
          Genau genommen ist es um spektakuläre 201 Prozent gestiegen. Zusammen
          mit Nidwalden ist Schwyz regelrecht davongezogen. Aber von unten her
          drängt Obwalden noch etwas schneller nach oben. Dort ist das
          durchschnittliche Reinvermögen seit 2003 gar um 205 Prozent gewachsen
          - von 174'606 auf 532'841 Franken. Die tiefen Steuern zeigen also auch
          in Obwalden Wirkung.
        </p>
        <div className='iframeWrapper'>
          <div className='chartTitle'>Nidwalden und Schwyz top, Obwalden holt auf</div>
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/deavn'
            // style={{ height: '100%' }}
          />
        </div>
        <p>
          Relativ wenig Dynamik verzeichnen dagegen Neuenburg, Freiburg und
          Bern, die in den 14 Jahren von 2003 bis 2017 alle weniger als 35
          Prozent zugelegt haben.
        </p>
      </>
    )
  },
  {
    nummer: 8,
    type: 'map',
    question: 'In welchem Kanton sind die Vermögen am ungleichsten verteilt?',
    correctAnswer: 'GE',
    erklaerung: (
      <>
        <h5>Interessant zu wissen:</h5>
        <p>
          In Genf besitzen die 0,6 Prozent Reichsten fast die Hälfte des
          gesamten Reinvermögens (48 Prozent). Sehr ungleich verteilt ist das
          Vermögen auch in Basel-Stadt und Nidwalden. Messen lässt sich
          die Ungleichverteilung mit dem sogenannten Gini-Index – einer Zahl
          zwischen 0 und 1. Je höher der Wert, desto stärker die Ungleichheit.
          Bei 1 besitzt einer alles und die anderen nichts, bei 0 ist das
          Vermögen aller gleich gross. Das Eidgenössische Finanzdepartement hat
          den Index fürs Jahr 2015 für alle Kantone berechnet:
        </p>
        <div className='iframeWrapper'>
          <div className='chartTitle'>
            In Genf sind die Vermögen am ungleichsten verteilt
          </div>
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/D8uZr/'
            // style={{ height: '100%' }}
          />
        </div>
        <p>
          Am gleichmässigsten ist das Vermögen in Uri verteilt. Auch in
          Graubünden, Glarus und St. Gallen ist die Kluft zwischen Arm und Reich
          für schweizerische Verhältnisse bescheiden. Tendenziell lässt sich
          feststellen, dass in vermögensstarken Kantonen die Ungleichheit
          grösser ist. Es gibt aber auch Ausnahmen: Die beiden Appenzeller
          Halbkantone weisen eine relativ moderate Vermögenskonzentration aus,
          obwohl ihr Durchschnittsvermögen über dem gesamtschweizerischen
          Schnitt liegt. Anders verhält es sich in den Kantonen Solothurn,
          Freiburg und Basel-Landschaft. Dort sind die Vermögen relativ ungleich
          verteilt, obwohl die Steuerpflichtigen ärmer sind als im Schweizer
          Schnitt.
        </p>
        <p>
          Im internationalen Vergleich sind die Vermögen in der Schweiz sehr
          ungleich verteilt. Solche Aussagen sind allerdings mit grosser
          Vorsicht zu geniessen. Denn die Datenbasis unterscheidet sich von Land
          zu Land stark, wird doch das Vermögen nicht überall gleich gemessen.
          In der Schweiz erfassen die Steuerbehörden etwa das
          Pensionskassenkapital nicht – ebenso wenig wie die 3. Säule und den
          Hausrat. Kommt hinzu, dass der Steuerwert von Immobilien deutlich
          unter dem Marktwert liegt. Das relativiert die Ungleichverteilung
          etwas, weil diese Vermögenswerte bei tieferen und mittleren Klassen
          stärker ins Gewicht fallen als bei sehr Reichen.
        </p>
        <p>
          Ein Blick zurück zeigt, dass die Schweizer Vermögenskonzentration vor
          hundert Jahren noch deutlich höher war als heute. Während des Ersten
          Weltkriegs sank sie, blieb dann lange stabil und fiel erneut in den
          70er-Jahren. Seit 1994 steigt sie wieder an. Vor allem die Vermögen
          der Allerreichsten sind seit der Jahrtausendwende markant gewachsen.
          Besonders stark nimmt die Ungleichverteilung in den Kantonen Tessin
          und Obwalden zu. Demgegenüber hat sich die Vermögenskonzentration in
          Zürich und Basel-Stadt seit der Jahrtausendwende nur wenig erhöht.
        </p>
      </>
    )
  }
]
